import { render, staticRenderFns } from "./channelPullConfiguration.vue?vue&type=template&id=6622ad1c&scoped=true"
import script from "./channelPullConfiguration.vue?vue&type=script&lang=js"
export * from "./channelPullConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6622ad1c",
  null
  
)

export default component.exports